// NewDashboardIndex.jsx
// Added the new postlogin code
// NewDashboardIndex.jsx
// NewDashboardIndex.jsx
import Layout from "./Layout";
import HeroSectionFinal from "./components/HeroSectionFinal";
import CourseGrid from "./components/CourseGrid";
import SectionTwoWrapper from "./components/SectionTwo/SectionTwoWrapper";
import SectionOneWrapper from "./components/SectionOne/SectionOneWrapper";
import Attendance from "./components/SectionOne/Attendance";
import { useEffect, useState } from "react";
import {
  fetchStudentAttendanceService,
  fetchStudentAttendanceStatusService,
} from "../../services/users.services";
import { useQuery } from "@tanstack/react-query";
import AttendanceModal from "../records/attendance-modal";
import ProgramInclusionVerificationModal from "./components/InclusionModal/ProgramInclusionVerificationModal";
import InstallmentAgreementAcceptanceModal from "./components/InstallmentAgreementAcceptanceModal";
import DashboardTour from "./components/DashboardTour";
const NewDashboardIndex = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [table, setTable] = useState([]);
  const [showAttendance, setShowAttendance] = useState(false);
  const [attendanceType, setAttendanceType] = useState("offline");
  const [isAttendanceActivated, setIsAttendanceActivated] = useState(false);
  const rawCategory = localStorage.getItem("category");

  const category =
    rawCategory && rawCategory !== "undefined" && rawCategory !== "null"
      ? rawCategory
      : null;
  const isLocked = localStorage.getItem("status") !== "active";

  const { data: attendanceStatus } = useQuery({
    queryFn: () =>
      fetchStudentAttendanceStatusService({
        category: localStorage.getItem("category"),
        program_id: localStorage.getItem("program_id"),
        batch_id: localStorage.getItem("batch_id"),
      }),
    queryKey: ["get-attendance-status"],
    enabled:
      !!localStorage.getItem("category") &&
      !!localStorage.getItem("program_id") &&
      !!localStorage.getItem("batch_id"),
  });

  const { data } = useQuery({
    queryFn: () =>
      fetchStudentAttendanceService({
        category: localStorage.getItem("category"),
        attendanceType: attendanceType,
      }),
    queryKey: ["get-attendance"],
    enabled:
      !!localStorage.getItem("category") &&
      showAttendance &&
      isAttendanceActivated,
  });

  console.log("category " + localStorage.getItem("category"))

  useEffect(() => {
    if (attendanceStatus?.data && attendanceStatus?.data.length > 0) {
      setShowAttendance(true);
      setAttendanceType(attendanceStatus?.data[0].status);
      setIsAttendanceActivated(true);
    } else {
      setShowAttendance(false);
    }
  }, [attendanceStatus]);

  useEffect(() => {
    if (data?.attendance) {
      setTable(data?.attendance?.attendance_details);
    }
  }, [data]);


  const [showInclusionModal, setShowInclusionModal] = useState(true);
  const [showAgreementModal, setShowAgreementModal] = useState(true);

  // Track blocking modals from TopBar (acknowledgement & expectations)
  // The tour must wait until ALL of these are closed
  const [topBarBlockingModals, setTopBarBlockingModals] = useState({
    acknowledgement: false,
    expectations: false,
  });

  useEffect(() => {
    const handleBlockingModalChange = (e) => {
      const { type, isOpen } = e.detail;
      setTopBarBlockingModals(prev => ({ ...prev, [type]: isOpen }));
    };
    window.addEventListener('tourBlockingModalChange', handleBlockingModalChange);
    return () => window.removeEventListener('tourBlockingModalChange', handleBlockingModalChange);
  }, []);

  // Tour can only start when ALL blocking modals are closed
  const canStartTour = !showInclusionModal
    && !showAgreementModal
    && !topBarBlockingModals.acknowledgement
    && !topBarBlockingModals.expectations;

  // alert(localStorage.getItem("category"))
  return (
    <Layout initialCollapsed={false} showInclusionModal={showInclusionModal}>
      {showInclusionModal && (
        <ProgramInclusionVerificationModal
          onClose={() => setShowInclusionModal(false)}
        />
      )}
      {showAgreementModal && !showInclusionModal && (
        <InstallmentAgreementAcceptanceModal
          onClose={() => setShowAgreementModal(false)}
        />
      )}
      <DashboardTour start={canStartTour} />

      <HeroSectionFinal />
      <CourseGrid />
      <div className="md:hidden w-full block mb-6">
        {showAttendance && !isLocked && category !== "44" && (
          <Attendance data={data} setIsModalOpen={setIsModalOpen} />
        )}
      </div>
      {showAttendance && category !== "44" && (
        <AttendanceModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          table={table}
        />
      )}
      <SectionOneWrapper />
      <SectionTwoWrapper />
    </Layout>
  );
};

export default NewDashboardIndex;


// import Sidebar from "./Sidebar";
// import TopBar from "./TopBar";
// import MobileSidebar from "./MobileSidebar";
// import HeroSectionFinal from "./HeroSectionFinal";
// import CourseGrid from "./CourseGrid";
// import StatusSection from "./StatusSection";
// import DailyChallengeCard from "./DailyChallengeCard";
// import { useState } from "react";
// import useScreenSize from "../../hooks/useScreenSize";

// const NewDashboardIndex = () => {
//   console.log("Index page is rendering with teal primary color");
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const { isMobile } = useScreenSize();

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//   };

//   return (
//     <div className="min-h-screen bg-background">
//       <div className="flex">
//         {/* Desktop Sidebar - Hidden on mobile */}
//         {!isMobile && (
//           <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
//         )}

//         {/* Mobile Sidebar */}
//         {isMobile && (
//           <MobileSidebar
//             isOpen={isMobileMenuOpen}
//             onClose={() => setIsMobileMenuOpen(false)}
//           />
//         )}

//         {/* Main Content */}
//         <div
//           className={`flex-1 min-w-0 ml-0 ${
//             !isMobile && !isCollapsed
//               ? "md:ml-64"
//               : !isMobile && isCollapsed
//               ? "md:ml-20"
//               : ""
//           } transition-all duration-300`}
//         >
//           <TopBar isMobile={isMobile} onMobileMenuToggle={toggleMobileMenu} />
//           <div className="p-4 md:p-8 pt-6">
//             <HeroSectionFinal />
//             <CourseGrid />
//             <StatusSection />
//             <DailyChallengeCard />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewDashboardIndex;

// import Sidebar from "@/components/dashboard/Sidebar";
// import TopBar from "@/components/dashboard/TopBar";
// import HeroSection from "@/components/dashboard/HeroSection";
// import CourseGrid from "@/components/dashboard/CourseGrid";
// import StatusSection from "@/components/dashboard/StatusSection";
// import DailyChallengeCard from "@/components/dashboard/DailyChallengeCard";
// import CalendarCard from "@/components/dashboard/CalendarCard";
// import BottomSection from "@/components/dashboard/BottomSection";
// import { useState } from "react";
// import HeroSectionFinal from "@/components/dashboard/HeroSectionFinal";

// const Index = () => {
//   console.log("Index page is rendering with teal primary color");
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   return (
//     <div className="min-h-screen bg-background">
//       <div className="flex">
//         {/* Sidebar */}
//         <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />

//         {/* Main Content */}
//         <div
//           className={`flex-1 min-w-0 ${
//             !isCollapsed ? "ml-0 md:ml-64" : "ml-0 md:ml-20"
//           } transition-all duration-300`}
//         >
//           <TopBar />
//           <div className="p-4 md:p-8 pt-6">
//             {/* <HeroSection /> */}
//             <HeroSectionFinal />
//             <CourseGrid />
//             <StatusSection />
//             <DailyChallengeCard />
//             {/* <div className="flex gap-6"> */}
//             {/* <BottomSection /> */}
//             {/* <CalendarCard /> */}
//             {/* </div> */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Index;
